import { Checkbox } from 'farmhub-ui-core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 320px;
  background: #fff;
`;

export const ProvinceWrapper = styled.div`
  width: 100%;
  height: 274px;

  overflow: auto;
`;

export const CheckboxWrapper = styled.div`
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin: 0px;
  }
  .ant-checkbox-wrapper {
    width: 100%;
    padding-bottom: 5px;
  }
`;

export const WrapperCheckBox = styled(Checkbox)<{ show: boolean }>`
  display: ${(params: any) => (params.show ? 'flex' : 'none')};
`;

export const WrapperChildCheckBox = styled(Checkbox)<{ show: boolean }>`
  padding-left: 20px !important;
  display: ${(params: any) => (params.show ? 'flex' : 'none')};
`;

export const IconWrapper = styled.div<{ hasFilter: boolean }>`
  width: fit-content;
  height: auto;
  padding: 4px;
  border-radius: 4px;
  background: ${props => (props.hasFilter ? '#e7f5e6' : 'inherit')} !important;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    path {
      fill: ${props =>
        props.hasFilter
          ? props.theme.colors.primary.main
          : props.theme.colors.text.primary} !important;
    }
  }

  cursor: pointer;

  &:hover {
    svg {
      path {
        fill: ${props => props.theme.colors.primary.main};
      }
    }
  }
`;
